import { useEffect, useState } from 'react'
import './keypad.css'

export function KeyPad({getValue, setValue, setClosed, setSubmitted, title="Keypad", preUnits = "", postUnits = "", defaultValue = {value: 0}, children}) {

    const [getStrVal, setStrVal] = useState("")

    useEffect(() => {
        function handleKeyDown(e) {
            if(e.keyCode >= 96 && e.keyCode <= 106) {
                buttonClick(e.keyCode - 96)
            } else if(e.keyCode == 110 || e.keyCode == 190) {
                buttonClick('.')
            } else if (e.keyCode >= 48 && e.keyCode <= 58) {
                buttonClick(e.keyCode - 58)
            } else {
                console.log(e.keyCode)
            }
        }
    
        document.addEventListener('keydown', handleKeyDown);
    
        // Don't forget to clean up
        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    function buttonClick(val) {
        try {
            setStrVal(prevStrVal => {
                const newStrVal = `${prevStrVal}${val}`;
                let newVal = parseFloat(newStrVal);
                setValue({...getValue, value: newVal});
                return newStrVal;
            });
        } catch {
            setStrVal(`${getValue.value}`);
        }
    }

    function Clear() {
        setValue({...getValue, value: 0});
        setStrVal('')
    }

    function UpdateFromChildren(event) {
        const newVal = {...getValue};
        newVal[event.target.name] = event.target.value;
        setValue(newVal)
    }

    return (<>
        <div className='center-blur-bg'>
            <div style={{display: "flex", alignItems: "end"}}>
                
                {children != null ? <form className='keypad_child_panel' onInputCapture={UpdateFromChildren}> {children} </form> : null}
                
                <div className='keypad'>
                    <div className='keypad_top'>
                        <div className='keypad_panel'> 
                            <h2> {title} </h2>
                        </div>
                        <button onClick={setClosed}> X </button>
                    </div>
                    <div className='keypad_outline'>
                        <h1> {getStrVal} </h1>
                        <hr/>
                        <div className='keypad_grid'>
                            {[...Array(9).keys()].map((_, idx) => {
                                return <button onClick={() => {buttonClick(idx + 1)}}> {idx + 1} </button>
                            })}
                            <button onClick={() => {buttonClick(".")}}> . </button>
                            <button onClick={() => {buttonClick(0)}}> 0 </button>
                            <button onClick={Clear}> C </button>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", alignItems: "end", flexDirection: "column"}}>
                    <button className='keypad_submit' onClick={setSubmitted}> ➔ </button>
                </div>
            </div>
        </div>
    </>)
}